<template>
  <div class="join-room">
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <label for="name">ルーム名</label>
          <input class="form-control" type="text" id="name" v-model="room.name" disabled>
        </div>
        <!-- <div class="form-group">
          <label for="n_members">人数</label>
          <input class="form-control" type="number" id="n_members" v-model="room.n_members" disabled>
        </div> -->
        <div class="form-group">
          <label for="password">パスワード</label>
          <input class="form-control" type="password" id="password" v-model="room.password">
        </div>
        <button type="button" name="button" class="btn btn-danger" @click="joinRoom">参加</button>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'join-room',
  components: {

  },
  data() {
    return {
      db: null,
      room: {
        id: null,
        name: 'asdf',
        // n_members: 3,
        password: ''
      },
      user: null
    }
  },
  created() {
    this.room.id = this.$route.params.room_id;

    // room情報を取得する
    this.db = firebase.firestore();
    this.db.collection('rooms').doc(this.room.id).get().then((doc)=>{
      this.room.name = doc.data().name;
    });

    firebase.auth().onAuthStateChanged((user)=>{
    if (user) {
        this.user = user;
    }
});
  },
  methods: {
    joinRoom() {
      this.db.collection('rooms').doc(this.room.id).get().then((doc)=>{
        if (doc.data().password === this.room.password){
          this.db.collection('rooms').doc(this.room.id).update({
            members: firebase.firestore.FieldValue.arrayUnion({uid: this.user.uid, name: this.user.displayName})
          });
          this.$router.push('/rooms/game/'+this.room.id);
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
